<template>
  <SimpleCardDialog
    v-model:dialog="model"
    max-width="600"
    show-cancel
    :title="$t('ConfirmDelete')"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      {{ $t('DeleteSelectItem') }}
    </template>

    <template #actions>
      <ActionButton
        delete
        @click="submit()"
      />
    </template>
  </SimpleCardDialog>
</template>

<script>
  import SimpleCardDialog from '../parts/dialog/SimpleCardDialog'
  import ActionButton from '../parts/button/ActionButton'

  export default {
    components: { ActionButton, SimpleCardDialog },
    props: {
      modelValue: Boolean,
      apiAddress: {
        type: String,
        default: ''
      },
      apiData: {
        type: Object,
        default: null
      }
    },
    emits: ['update:model-value', 'reload'],
    data: () => ({
      model: false
    }),
    watch: {
      modelValue () { this.model = this.modelValue },
      model () {
        this.$emit('update:model-value', this.model)
      }
    },
    methods: {
      submit () {
        if (this.apiAddress) {
          this.$http.delete(this.apiAddress, { params: this.apiData }).then(
            (res) => {
              this.$emit('reload')
              this.model = false
            },
            (error) => {
              if (error.response.status === 404) {
                this.model = false
              }
            })
        }
      }
    }
  }
</script>

<style scoped>

</style>
